import { render, staticRenderFns } from "./CommissionRank.vue?vue&type=template&id=0bf4da43&scoped=true"
import script from "./CommissionRank.vue?vue&type=script&lang=js"
export * from "./CommissionRank.vue?vue&type=script&lang=js"
import style0 from "./CommissionRank.vue?vue&type=style&index=0&id=0bf4da43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf4da43",
  null
  
)

export default component.exports